import { render, staticRenderFns } from "./EditAiBusinessPromoter.vue?vue&type=template&id=f2d57bec&scoped=true&"
import script from "./EditAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./EditAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./EditAiBusinessPromoter.vue?vue&type=style&index=0&id=f2d57bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d57bec",
  null
  
)

export default component.exports